<template>
  <v-container fluid v-if="story != null">
    <v-layout row wrap>
      <story-edit-fields v-model="story" type="edit"></story-edit-fields>
    </v-layout>
  </v-container>
</template>

<script>
import StoryEditFields from '@/components/StoryEditFields.vue';

export default {
  name: 'EditStoryView',
  components: { StoryEditFields },
  computed: {
    story: {
      get() {
        return this.$store.getters.getStory(this.$route.params.id);
      },
      set(value) {
        this.$store.commit('updateStory', value);
        this.$router.push({ name: 'Stories' });
      },
    },
  },
};
</script>
